import React from 'react';
import { Box, InputAdornment, Pagination, TextField, Typography } from '@mui/material';
import { Search } from 'lucide-react';
import { useIntl } from 'react-intl';
import { portalColors, portalFocus, portalInput } from '../portal-styles';

export const normalizePortalText = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();

export function PortalFilter({ id, label, value, onChange }) {
  return <TextField id={id} fullWidth value={value} onChange={event => onChange(event.target.value)}
    placeholder={label} inputProps={{ 'aria-label': label }}
    InputProps={{ startAdornment: <InputAdornment position="start"><Search size={18} strokeWidth={1.7} color={portalColors.muted} aria-hidden="true" /></InputAdornment> }}
    sx={portalInput} />;
}

export function PortalPagination({ page, count, total, pageSize, onChange }) {
  const intl = useIntl();
  if (count <= 1) return null;
  return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, pt: 3 }}>
    <Typography variant="body2" sx={{ color: portalColors.muted }} role="status">
      {intl.formatMessage({ id: 'portal.pagination.range' }, { start: (page - 1) * pageSize + 1, end: Math.min(page * pageSize, total), total })}
    </Typography>
    <Pagination page={page} count={count} onChange={(_, next) => onChange(next)} siblingCount={0} boundaryCount={1}
      aria-label={intl.formatMessage({ id: 'portal.pagination.label' })}
      getItemAriaLabel={(type, number, selected) => intl.formatMessage({ id: type === 'page'
        ? selected ? 'portal.pagination.current' : 'portal.pagination.page'
        : type === 'previous' ? 'portal.pagination.previous' : 'portal.pagination.next' }, { page: number })}
      sx={{ '& .MuiPaginationItem-root': { ...portalFocus, minWidth: 40, height: 40, color: portalColors.ink,
        '&.Mui-selected, &.Mui-selected:hover': {
          bgcolor: `${portalColors.soft} !important`,
          color: `${portalColors.action} !important`,
          fontWeight: 600,
        },
      } }} />
  </Box>;
}
